export const formatNumberSpouse = (number: string) => {
  return number.replace(/[^0-9]/g, '');
};
